import { EditOpportunity, GetOpportunity, RegisterOpportunity } from "@/dtos/Opportunity.dto";
import { StateObject } from "@/dtos/State.dto";
import Opportunity from "@/services/opportunity/opportunity";
import {
  CLEAR_OPPORTUNITY_ISLOADING,
  DELETE_OPPORTUNITY,
  EDIT_OPPORTUNITY,
  GET_OPPORTUNITIES,
  GET_OPPORTUNITY,
  MOVE_OPPORTUNITY,
  REGISTER_OPPORTUNITY,
} from "@/store/action-types";
import { SET_ERRORMSG, SET_OPPORTUNITIES, SET_OPPORTUNITY } from "@/store/mutation-types";
import { AxiosResponse } from "axios";
import { Module } from "vuex";

const opportunity: Module<any, {}> = {
  state: {
    opportunity: {
      data: null,
      isLoading: false,
    },
    opportunities: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    opportunity: (state: { opportunity: any }) => state.opportunity,
    opportunities: (state: { opportunities: any }) => state.opportunities,
  },
  mutations: {
    [SET_OPPORTUNITY]: (
      state: { opportunity: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.opportunity.data = payload.data;
      state.opportunity.isLoading = payload.isLoading;
    },
    [SET_OPPORTUNITIES]: (
      state: { opportunities: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.opportunities.data = payload.data;
      state.opportunities.isLoading = payload.isLoading;
    },
  },
  actions: {
    [REGISTER_OPPORTUNITY]: async ({ commit }: any, payload: any) => {
      commit(SET_OPPORTUNITY, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await Opportunity.registerOpportunity(
          payload as RegisterOpportunity
        );

        if (result) {
          if (result.data.status) {
            commit(SET_OPPORTUNITY, { data: result.data.data, isLoading: false });
            return result.data.data;
          }
          commit(SET_OPPORTUNITY, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg || "Failed to register opportunity");
          return false;
        } else {
          commit(SET_OPPORTUNITY, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_OPPORTUNITY, { data: null, isLoading: false });
        const errorMessage =
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          error?.message ||
          "An error occurred while registering the opportunity";
        commit(SET_ERRORMSG, errorMessage);
        return false;
      }
    },
    [GET_OPPORTUNITIES]: async ({ commit }: any, payload: any) => {
      commit(SET_OPPORTUNITIES, { data: null, isLoading: true });

      const result: AxiosResponse = await Opportunity.getOpportunities(payload as GetOpportunity);

      if (result) {
        if (result.data.status) {
          commit(SET_OPPORTUNITIES, {
            data: result.data.data,
            isLoading: false,
          });
          return true;
        }
        commit(SET_OPPORTUNITIES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OPPORTUNITIES, { isLoading: false });
        return false;
      }
    },
    [GET_OPPORTUNITY]: async ({ commit }: any, payload: any) => {
      commit(SET_OPPORTUNITY, { data: null, isLoading: true });

      const result: AxiosResponse = await Opportunity.getOpportunities(payload as GetOpportunity);

      if (result) {
        if (result.data.status) {
          commit(SET_OPPORTUNITY, {
            data: result.data.data[0],
            isLoading: false,
          });
          return true;
        }
        commit(SET_OPPORTUNITY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OPPORTUNITY, { isLoading: false });
        return false;
      }
    },
    [EDIT_OPPORTUNITY]: async ({ commit }: any, payload: any) => {
      commit(SET_OPPORTUNITY, { data: null, isLoading: true });

      const result: AxiosResponse = await Opportunity.editOpportunity(payload as EditOpportunity);

      if (result) {
        if (result.data.status) {
          commit(SET_OPPORTUNITY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_OPPORTUNITY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OPPORTUNITY, { isLoading: false });
        return false;
      }
    },
    [MOVE_OPPORTUNITY]: async ({ commit }: any, payload: any) => {
      commit(SET_OPPORTUNITY, { data: null, isLoading: true });

      const result: AxiosResponse = await Opportunity.moveOpportunity(payload as EditOpportunity);

      if (result) {
        if (result.data.status) {
          commit(SET_OPPORTUNITY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_OPPORTUNITY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OPPORTUNITY, { isLoading: false });
        return false;
      }
    },
    [DELETE_OPPORTUNITY]: async ({ commit }: any, payload: string) => {
      commit(SET_OPPORTUNITY, { data: { id: payload }, isLoading: true });

      const result: AxiosResponse = await Opportunity.deleteOpportunity(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_OPPORTUNITY, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_OPPORTUNITY, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_OPPORTUNITY, { isLoading: false });
        return false;
      }
    },
    [CLEAR_OPPORTUNITY_ISLOADING]: ({ commit }) => {
      commit(SET_OPPORTUNITY, { isLoading: false });
      commit(SET_OPPORTUNITIES, { isLoading: false });
    },
  },
};

export default opportunity;
